import React, { useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const Navbar = () => {
  const { user, logout, isAdmin } = useContext(AuthContext);
  const navigate = useNavigate();
  const { branch } = useParams() || {};

  // Branch slug-to-label mapping
  const branchLabels = {
    aljumbo1: 'Al Jumbo 1',
    aljumbo2: 'Al Jumbo 2',
    aljumbo3: 'Al Jumbo 3',
    aljumboalrai: 'Al Jumbo Al Rai',
    doorservice: 'Door Service',
    doorservice2: 'Door Service 2',
    goldenhouse: 'Golden House',
    warehouse: 'Warehouse',
  };
  const getBranchDisplayName = (branch) => {
    if (!branch) return '';
    return branchLabels[branch] || branch;
  };

  const handleLogout = () => {
    logout();
    navigate(`/login/${branch || localStorage.getItem('branch') || 'aljumbo1'}`);
  };

  if (!user) {
    return null;
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container">
        <Link className="navbar-brand" to={`/${branch || localStorage.getItem('branch') || 'aljumbo1'}`}>
          <img src="/logo.png" alt="AJC Logo" style={{ maxHeight: '40px' }} />
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {/* Removed Add Product and Import Products from header menu */}
          </ul>
          <div className="d-flex navbar-nav">
            <button className="btn btn-outline-light" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
